import React, { useState, useEffect } from 'react';
import Note from './Note';
import './App.css';

function App() {
  // Initialize notes from localStorage
  const [notes, setNotes] = useState(() => {
    const savedNotes = localStorage.getItem('notes');
    return savedNotes ? JSON.parse(savedNotes) : [];
  });
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  // Save notes to localStorage
  useEffect(() => {
    localStorage.setItem('notes', JSON.stringify(notes));
  }, [notes]);

  // Handle input changes
  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleContentChange = (event) => {
    setContent(event.target.value);
  };

  // Add a new note
  const addNote = (event) => {
    event.preventDefault();
    if (title.trim() === '' || content.trim() === '') return;
    setNotes([...notes, { id: Date.now(), title, content }]);
    setTitle('');
    setContent('');
  };

  // Delete a note
  const deleteNote = (id) => {
    setNotes(notes.filter((note) => note.id !== id));
  };

  // Edit a note
  const editNote = (id, updatedTitle, updatedContent) => {
    if (updatedTitle.trim() === '' || updatedContent.trim() === '') return;
    setNotes(
      notes.map((note) =>
        note.id === id
          ? { ...note, title: updatedTitle, content: updatedContent }
          : note
      )
    );
  };

  return (
    <div className="App">
      <h1>Notes App</h1>
      <form onSubmit={addNote} className="note-form">
        <input
          type="text"
          value={title}
          onChange={handleTitleChange}
          placeholder="Note Title"
        />
        <textarea
          value={content}
          onChange={handleContentChange}
          placeholder="Note Content"
          rows="4"
        />
        <button type="submit">Add Note</button>
      </form>
      <div className="notes-list">
        {notes.length === 0 ? (
          <p>No notes yet. Add one above!</p>
        ) : (
          notes.map((note) => (
            <Note
              key={note.id}
              note={note}
              onDelete={deleteNote}
              onEdit={editNote}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default App;